import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function PageHeader({ overline, title, lead, image, cta }) {
  return (
    <section className="bg-[#FAFAFA] border-b border-[#E5E7EB]">
      <div className="ccdr-container py-16 lg:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <div className={image ? "lg:col-span-7" : "lg:col-span-9"}>
          {overline && <p className="ccdr-eyebrow mb-6">{overline}</p>}
          <h1 className="ccdr-h1 mb-6">{title}</h1>
          {lead && <p className="ccdr-lead max-w-2xl">{lead}</p>}
          {cta && (
            <Link to={cta.to} className="ccdr-btn-primary mt-8">
              {cta.label} <ArrowRight className="w-4 h-4" />
            </Link>
          )}
        </div>
        {image && (
          <div className="lg:col-span-5">
            <div className="aspect-[4/3] w-full overflow-hidden border border-[#E5E7EB]">
              <img
                src={image}
                alt=""
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
